module.exports = {
	"id": "NC",
	"name": "New Caledonia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.043526,
			"9": null,
			"10": null,
			"11": 0.018654,
			"12": 0.006218,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.037308,
			"24": null,
			"25": 0.006218,
			"26": null,
			"27": null,
			"28": 0.024872,
			"29": null,
			"30": null,
			"31": 0.012436,
			"32": 0.018654,
			"33": 0.012436,
			"34": 0.006218,
			"35": 0.03109,
			"36": 0.06218,
			"37": 0.006218,
			"38": 0.012436,
			"39": null,
			"40": 0.024872,
			"41": 0.006218,
			"42": 0.012436,
			"43": 0.099488,
			"44": 0.03109,
			"45": 0.037308,
			"46": 0.161668,
			"47": 0.049744,
			"48": 0.049744,
			"49": 2.20739,
			"50": 0.037308,
			"51": 0.460132,
			"52": 0.348208,
			"53": 21.439664,
			"54": 5.359916,
			"55": 0.024872,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": 0.012436,
			"15": null,
			"16": 0.018654,
			"17": 0.012436,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.037308,
			"25": 0.006218,
			"26": 0.006218,
			"27": null,
			"28": null,
			"29": 0.012436,
			"30": 0.006218,
			"31": 0.012436,
			"32": null,
			"33": 0.012436,
			"34": 0.018654,
			"35": 0.161668,
			"36": 0.018654,
			"37": 0.049744,
			"38": 0.09327,
			"39": 0.037308,
			"40": 0.03109,
			"41": 0.180322,
			"42": 0.049744,
			"43": 0.267374,
			"44": 0.080834,
			"45": 0.323336,
			"46": 0.06218,
			"47": 0.397952,
			"48": 1.386614,
			"49": 10.334316,
			"50": 0.068398,
			"51": 0.012436,
			"52": null,
			"3.5": null,
			"3.6": 0.012436
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.024872,
			"37": 0.012436,
			"38": null,
			"39": 0.006218,
			"40": 0.230066,
			"41": 0.03109,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.018654
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.105706,
			"6": 0.006218,
			"7": 0.012436,
			"8": 0.640454,
			"9": 0.298464,
			"10": 2.163864,
			"3.1": null,
			"3.2": null,
			"5.1": 0.24872,
			"6.1": 0.21763,
			"7.1": 0.006218,
			"9.1": 2.033286
		},
		"ios_saf": {
			"8": 0,
			"10": 3.88838725062,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.104787537052,
			"8.1-8.4": 0.193590534555,
			"9.0-9.2": 0.0923551174022,
			"9.3": 1.40900756037
		},
		"android": {
			"3": 0,
			"4": 0.0683398604651,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00854248255814,
			"4.1": 0.246511639535,
			"4.2-4.3": 0.616279098837,
			"4.4": 1.41317068605,
			"4.4.3-4.4.4": 1.42537423256
		},
		"ie": {
			"6": null,
			"7": 0.024872,
			"8": 0.180322,
			"9": 0.118142,
			"10": 0.27981,
			"11": 4.203368,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0125192027652,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000347755632366
		},
		"edge": {
			"12": 0.118142,
			"13": 0.702634,
			"14": 2.05194
		},
		"ie_mob": {
			"10": 0.0611512112676,
			"11": 0.248972788732
		},
		"bb": {
			"7": 0.001891,
			"10": null
		},
		"samsung": {
			"0": 6.8076
		},
		"and_uc": {
			"0": 0.083204
		},
		"op_mini": {
			"0": 0.168669041602
		},
		"and_chr": {
			"0": 23.80725
		},
		"and_ff": {
			"0": 0.064294
		}
	},
	"total": 98.829455
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NC.json
 ** module id = 605
 ** module chunks = 0
 **/